module.exports = __webpack_public_path__ + "static/media/fliq.45b3037f.png";